import { appConfig } from "src/config";
import { LibCategories, loadScript } from "src/utils/scriptLoader";

export function loadOptimizely() {
  const optimizelyProjectId = appConfig.OPTIMIZELY_PROJECT_ID_EN;

  return loadScript(`https://cdn.optimizely.com/js/${optimizelyProjectId}.js`, [
    LibCategories.functionalCookies,
  ]);
}
